<template>
    <CAlert>
        <slot />
    </CAlert>
</template>

<script setup>
import { CAlert } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
